import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addTeacher, resetAddTeacher } from "../../../../../../state/actions/addTeacherAction";
import { getCourseTeachers } from "../../../../../../state/actions/getCourseTeachersAction";
import { changeScrollPopup } from "../../../../../../utils/utlis";
import { warning_blue_img } from "../../../../../../assets/images/images";
import AlertConfirmationPopup from "../../../../../../components/AlertConformationPopup/AlertConformationPopup";
import EmailResultToast from "./EmailResultToast";

const AddTeachers = ({ course, token, changeScrollPopupProp, onTransferComplete }) => {
  const dispatch = useDispatch();
  const addTeacherState = useSelector((state) => state.addTeacher);

  const collaboratorsList = useSelector((state) => state.getCourseTeachers?.teachers ?? []);
  const demo = useSelector((state) => state.getCourseTeachers ?? []);
  const modalRef = useRef(null);

  



  const [isOpen, setIsOpen] = useState(false);
  const [teacherInputValue, setTeacherInputValue] = useState("");
  const [teacherEmails, setTeacherEmails] = useState([]);
  const [teacherFormErrors, setTeacherFormErrors] = useState({ teachers: "" });
  const [teacherRole, setTeacherRole] = useState("editor");
  const [transferConfirmPayload, setTransferConfirmPayload] = useState(null);
  const [openAccessRoleKey, setOpenAccessRoleKey] = useState(null);
  const [transferCollaboratorPayload, setTransferCollaboratorPayload] = useState(null);
  const scrollPopup = changeScrollPopupProp || changeScrollPopup;

  useEffect(() => {
    if (openAccessRoleKey == null) return;
    const handleClickOutside = (e) => {
      // This dropdown is rendered from two places against the same open-key
      // state, so a single element ref can only ever point at one of them —
      // interacting with the other reads as "outside" and closes the menu
      // before the option's click fires. Match on the row key instead.
      const wrapper = e.target?.closest?.("[data-access-role-key]");
      if (wrapper?.dataset?.accessRoleKey === String(openAccessRoleKey)) return;
      setOpenAccessRoleKey(null);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [openAccessRoleKey]);

  // useEffect(() => {
  //   if (teacherEmails.length > 1 && teacherRole === "owner") {
  //     setTeacherRole("editor");
  //   }
  // }, [teacherEmails.length, teacherRole]);

  const openModal = () => {
    setTeacherInputValue("");
    setTeacherFormErrors({ teachers: "" });
    setTeacherEmails([]);
    setTeacherRole("editor");
    setIsOpen(true);
    scrollPopup("auto", "view-course-details-share-form");
  };

  const closeModal = () => {
    setTeacherInputValue("");
    setTeacherFormErrors({ teachers: "" });
    setTeacherEmails([]);
    setTeacherRole("editor");
    setIsOpen(false);
    scrollPopup("auto", "view-course-details-share-form");
  };

  useEffect(() => {
    if (isOpen) {
      scrollPopup("hidden", "view-course-details-share-form");
    }
  }, [isOpen]);

  const showEmailResultToast = (addedEmails, failedEmails) => {
    toast(
      ({ closeToast }) => (
        <EmailResultToast closeToast={closeToast} addedEmails={addedEmails} failedEmails={failedEmails} />
      ),
      {
        position: "top-right",
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        icon: false,
        style: { background: "transparent", boxShadow: "none", padding: 0 },
      }
    );
  };

  useEffect(() => {
    if (addTeacherState?.success && addTeacherState?.response) {
      const res = addTeacherState.response;
      const added = res.added ?? [];
      const errors = res.errors ?? [];
      const addedCount = added.length;
      const errorCount = errors.length;
      const isRoleUpdate = addTeacherState?.isRoleUpdate;

      // PUT role-update returns { detail: "Role updated successfully." } (no added array)
      if (isRoleUpdate && res.detail) {
        toast.success(res.detail || "Role updated successfully.", {
          position: "top-right",
        });
        dispatch(resetAddTeacher());
        if (course?.course_id && token) dispatch(getCourseTeachers(course.course_id, token));
        return;
      }

      if (addedCount > 0 && errorCount === 0) {
        if (isRoleUpdate) {
          toast.success("Role updated successfully.", { position: "top-right" });
        } else {
          const addedEmails = added.map((t) => t.email).filter(Boolean);
          showEmailResultToast(addedEmails, []);
          closeModal();
        }
        dispatch(resetAddTeacher());
        if (course?.course_id && token) dispatch(getCourseTeachers(course.course_id, token));
      } else if (addedCount > 0 && errorCount > 0) {
        const addedEmails = added.map((t) => t.email).filter(Boolean);
        const failedEmails = errors.map((e) => {
          const email = e.data?.email || "Unknown";
          const reason =
            (e.errors?.email && e.errors.email[0]) ||
            (e.errors && Object.values(e.errors).flat().find(Boolean)) ||
            "Failed to add";
          return { email, reason };
        });
        showEmailResultToast(addedEmails, failedEmails);
        dispatch(resetAddTeacher());
        if (course?.course_id && token) dispatch(getCourseTeachers(course.course_id, token));
        closeModal();
      } else if (errorCount > 0) {
        const failedEmails = errors.map((e) => {
          const email = e.data?.email || "Unknown";
          const reason =
            (e.errors?.email && e.errors.email[0]) ||
            (e.errors && Object.values(e.errors).flat().find(Boolean)) ||
            "Failed to add";
          return { email, reason };
        });
        showEmailResultToast([], failedEmails);
        dispatch(resetAddTeacher());
        if (course?.course_id && token) dispatch(getCourseTeachers(course.course_id, token));
        closeModal();
      } else {
        toast.error("Failed to add teacher.", { position: "top-right" });
        dispatch(resetAddTeacher());
      }
    } else if (addTeacherState?.error && addTeacherState?.response?.errors?.length > 0) {
      // All collaborators failed: success is false but response contains errors list
      const errors = addTeacherState.response.errors;
      const failedEmails = errors.map((e) => {
        const email = e.data?.email || "Unknown";
        const reason =
          (e.errors?.email && e.errors.email[0]) ||
          (e.errors && Object.values(e.errors).flat().find(Boolean)) ||
          "Failed to add";
        return { email, reason };
      });
      showEmailResultToast([], failedEmails);
      dispatch(resetAddTeacher());
      if (course?.course_id && token) dispatch(getCourseTeachers(course.course_id, token));
      closeModal();
    } else if (addTeacherState?.error) {
      toast.error("Failed to add teacher.", { position: "top-right" });
      dispatch(resetAddTeacher());
    }
  }, [addTeacherState?.success, addTeacherState?.error, addTeacherState?.response]);

  const validateTeacherEmail = (email) => {
    return /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email);
  };

  const handleTeacherInputChange = (e) => {
    setTeacherInputValue(e.target.value); 
    setTeacherFormErrors({ teachers: "" });
  };

  // const processTeacherInputVal = (newVal, withRole = true) => {
  //   if (!newVal) return;
  //   if (!validateTeacherEmail(newVal)) {
  //     setTeacherFormErrors({ teachers: "Please enter a valid email" });
  //     return;
  //   }
  //   const existingEmails = teacherEmails.map((t) => (typeof t === "string" ? t : t.email));
  //   if (existingEmails.includes(newVal)) {
  //     setTeacherFormErrors({ teachers: "Email already added" });
  //     return;
  //   }
  //   if (withRole) {
  //     setTeacherEmails((old) => [...old, { email: newVal, role: teacherRole }]);
  //   } else {
  //     setTeacherEmails((old) => [...old, newVal]);
  //   }
  //   setTeacherFormErrors({ teachers: "" });
  // };

  //PR1-I2247
  const processTeacherInputVal = (newVal, withRole = true) => {
  if (!newVal) return;

  const email = newVal.toLowerCase().trim();

  if (!validateTeacherEmail(email)) {
    setTeacherFormErrors({
      teachers: "Please enter a valid email",
    });
    return;
  }

  const existingEmails = teacherEmails.map((t) =>
    (typeof t === "string" ? t : t.email).toLowerCase().trim()
  );

  if (existingEmails.includes(email)) {
    setTeacherFormErrors({
      teachers: "Email already added",
    });
    return;
  }

  if (withRole) {
    setTeacherEmails((old) => [
      ...old,
      { email, role: teacherRole },
    ]);
  } else {
    setTeacherEmails((old) => [...old, email]);
  }

  setTeacherFormErrors({
    teachers: "",
  });
};
  const handleTeacherKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputValues = teacherInputValue.trim().split(/[\s,]+/);
      inputValues.forEach((value) => processTeacherInputVal(value.trim(), false));
      setTeacherInputValue("");
    }
  };

  const handleTeacherPaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const emailArray = pastedText.split(/,|\s+/).filter((email) => email.trim() !== "");
    emailArray.forEach((email) => processTeacherInputVal(email.trim()));
  };

  const handleAddTeacher = (e) => {
    e.preventDefault();
    const trimmed = teacherInputValue.trim();
    if (!trimmed) return;
    if (!validateTeacherEmail(trimmed)) {
      setTeacherFormErrors({ teachers: "Please enter a valid email" });
      return;
    }
    const existingEmails = teacherEmails.map((t) => (typeof t === "string" ? t : t.email));
    if (existingEmails.includes(trimmed)) {
      setTeacherFormErrors({ teachers: "Email already added" });
      return;
    }
    setTeacherEmails((old) => [...old, { email: trimmed, role: teacherRole }]);
    setTeacherInputValue("");
    setTeacherFormErrors({ teachers: "" });
  };

  const handleDeleteTeacher = (email) => {
    setTeacherEmails((prev) => prev.filter((t) => (typeof t === "string" ? t : t.email) !== email));
  };

  const handleInviteTeachers = () => {
    if (!course?.course_id || teacherEmails.length <= 0 || !token) return;

    const emailsToInvite = teacherEmails.map((item) =>
      (typeof item === "string" ? item : item.email).trim().toLowerCase()
    );
    const collaboratorEmails = (collaboratorsList ?? [])
      .map((c) => (c?.email ?? "").trim().toLowerCase())
      .filter(Boolean);
    const alreadyCollaborator = emailsToInvite.find((email) =>
      collaboratorEmails.includes(email)
    );
    if (alreadyCollaborator) {
      toast.error("You are adding a teacher who is already a collaborator.", {
        position: "top-right",
      });
      return;
    }

    const payload = teacherEmails.map((item) => {
      const email = typeof item === "string" ? item : item.email;
      const role = teacherRole;
      return { email, role };
    });
    if (teacherRole === "owner") {
      const teacherName =
        teacherEmails.length === 1
          ? (typeof teacherEmails[0] === "string" ? teacherEmails[0] : teacherEmails[0].email)
          : "the selected user(s)";
      setTransferConfirmPayload({ payload, teacherName });
      setIsOpen(false);
      return;
    }
    dispatch(addTeacher(course.course_id, payload, token));
  };

  return (
    <>
      {transferConfirmPayload && (
        <AlertConfirmationPopup
          alert_image={warning_blue_img}
          alert_title1={`Are you sure you want to transfer this course to ${transferConfirmPayload.teacherName}?`}
          alert_title2="You will no longer be able to manage permissions for this course"
          btn1="Cancel"
          btn2="Transfer Course"
          onCancel={() => setTransferConfirmPayload(null)}
          onAccept={() => {
            dispatch(addTeacher(course.course_id, transferConfirmPayload.payload, token));
            setTransferConfirmPayload(null);
            setTimeout(() => {
              onTransferComplete?.();
            }, 200);
          }}
        />
      )}
      {transferCollaboratorPayload && (
        <AlertConfirmationPopup
          alert_image={warning_blue_img}
          alert_title1={`Are you sure you want to transfer this course to ${transferCollaboratorPayload.collab?.name ?? transferCollaboratorPayload.collab?.email ?? "this teacher"}?`}
          alert_title2="You will no longer be able to manage permissions for this course"
          btn1="Cancel"
          btn2="Transfer Course"
          onCancel={() => setTransferCollaboratorPayload(null)}
          onAccept={() => {
            const { collab } = transferCollaboratorPayload;
            if (course?.course_id && token && collab?.id) {
              dispatch(addTeacher(course.course_id, { id: collab.id, role: "owner" }, token, true));
            }
            setTransferCollaboratorPayload(null);
            setTimeout(() => {
              onTransferComplete?.();
            }, 200);
          }}
        />
      )}
      <div type="button" className="add-lesson-btn">
        {
          course?.my_role === "owner" && (
            <button type="button" onClick={openModal}>
              <i className="fa-solid fa-plus"></i>
              Add Teachers
            </button>
          )
        }

      </div>

      {isOpen && (
        <div className="view-course-details-share-form">
          <div ref={modalRef} className="view-course-details-share-folder desktop-invite-modal">
            <h2 style={{ border: "none" }}>Add Teacher</h2>
            <div className="view-course-details-inner-wrapper">
              <div className="copy-link-or-path-folder invite-course-wrapper invite-student-popup-folder">
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                  }}
                >
                  <div
                    className="add-teacher-emails-box pt-1"
                    style={{
                      flex: 1,
                      minWidth: 0,
                      padding: "2px 12px",
                      overflowY: "auto",
                      border: teacherFormErrors.teachers ? "1px solid red" : "1px solid #d0d0d0",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                      display: "flex",
                      flexWrap: "wrap",
                      alignContent: "flex-start",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {teacherEmails.map((item, index) => {
                      const email = typeof item === "string" ? item : item.email;
                      const role = typeof item === "string" ? null : item.role;
                      return (
                        <span
                          key={`${email}-${index}`}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "5px 10px 5px 12px",
                            backgroundColor: "#e8e8e8",
                            borderRadius: "16px",
                            fontSize: "0.9rem",
                          }}
                        >
                          <span>
                            {email}
                            {/* {role && (
                              <span style={{ marginLeft: "4px", color: "#666", fontSize: "0.85em" }}>
                                ({role.charAt(0).toUpperCase() + role.slice(1)})
                              </span>
                            )} */}
                          </span>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDeleteTeacher(email);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              color: "#666",
                              fontSize: "14px",
                              lineHeight: 1,
                            }}
                            aria-label="Remove"
                          >
                            <i className="fa-solid fa-xmark" />
                          </button>
                        </span>
                      );
                    })}
                    <input
                      type="text"
                      name="teachers"
                      placeholder={teacherEmails.length === 0 ? "example@example.com and press enter" : ""}
                      value={teacherInputValue}
                      onChange={handleTeacherInputChange}
                      onKeyDown={handleTeacherKeyDown}
                      onPaste={handleTeacherPaste}
                      className="!mb-1"
                      style={{
                        flex: "1 1 140px",
                        minWidth: "140px",
                        border: "none",
                        outline: "none",
                        padding: "6px 4px",
                        fontSize: "1rem",
                      }}
                    />
                  </div>
                  {teacherEmails.length > 0 && (
                    <div
                      className="add-teacher-dropdown-box"
                      style={{
                        flex: "0 0 120px",
                        width: "120px",
                        maxWidth: "120px",
                        height: "45px",
                        maxHeight: "45px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 8px",
                        border: "1px solid #d0d0d0",
                        borderRadius: "6px",
                        backgroundColor: "#f5f5f5",
                        alignSelf: "flex-start",
                        flexShrink: 0,
                      }}
                    >
                      <select
                        className="add-teacher-role-dropdown"
                        value={teacherEmails.length > 1 && teacherRole === "owner" ? "editor" : teacherRole}
                        onChange={(e) => {
                          const role = e.target.value;
                          setTeacherRole(role);
                          const trimmed = teacherInputValue.trim();
                          if (trimmed && validateTeacherEmail(trimmed)) {
                            const existingEmails = teacherEmails.map((t) => (typeof t === "string" ? t : t.email));
                            if (!existingEmails.includes(trimmed)) {
                              setTeacherEmails((old) => [...old, { email: trimmed, role }]);
                              setTeacherInputValue("");
                              setTeacherFormErrors({ teachers: "" });
                            }
                          }
                        }}
                        style={{
                          width: "100%",
                          minWidth: 0,
                          padding: "8px 28px 8px 12px",
                          border: "none",
                          borderRadius: "4px",
                          backgroundColor: "transparent",
                          fontSize: "1rem",
                          cursor: "pointer",
                          outline: "none",
                          appearance: "none",
                          backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M1 4l5 5 5-5H1z'/%3E%3C/svg%3E\")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 10px center",
                        }}
                      >
                        {teacherEmails.length === 1 && (
                          <option value="owner">Owner</option>
                        )}
                        <option value="editor">Editor</option>
                        <option value="viewer">Viewer</option>
                      </select>
                    </div>
                  )}
                </div>
                {teacherFormErrors.teachers && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "0.8rem",
                      textAlign: "left",
                      margin: "0.5rem 0",
                    }}
                  >
                    {teacherFormErrors.teachers}
                  </p>
                )}
              </div>
            </div>

            <div
              className="add-teacher-collaborators-list"
              style={{
                marginTop: "16px",
                marginBottom: "16px",
                maxHeight: "240px",
                overflowY: "auto",
                borderRadius: "8px",
              }}
            >
              {Array.isArray(collaboratorsList) && collaboratorsList.length > 0 ? (
                collaboratorsList.map((collab, index) => {
                  const roleCode = (collab?.teacher_collaborator_roles?.code ?? "").toString().toLowerCase();
                  const roleLabels = { owner: "Owner", editor: "Editor", viewer: "Viewer", remove_user: "Remove User" };
                  const currentLabel = roleLabels[roleCode] ?? "Editor";
                  const isOwner = roleCode === "owner";
                  const rowKey = collab?.id ?? collab?.teacher_id ?? collab?.email;
                  const isOpen = openAccessRoleKey === rowKey;

                  const accessOptions = [
                    { value: "owner", label: "Owner" },
                    { value: "editor", label: "Editor" },
                    { value: "viewer", label: "Viewer" },
                    { value: "remove_user", label: "Remove User" },
                  ];

                  const handleSelectRole = (newRole) => {
                    if (newRole === "owner") {
                      setIsOpen(false);
                      setTransferCollaboratorPayload({ collab });
                    } else {
                      if (course?.course_id && token && collab?.id) {
                        dispatch(addTeacher(course.course_id, { id: collab.id, role: newRole }, token, true));
                      }
                    }
                    setOpenAccessRoleKey(null);
                  };

                  return (
                    <div
                      key={rowKey}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 16px",
                        gap: "12px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0, flex: 1 }}>
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            flexShrink: 0,
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1rem",
                            fontWeight: 600,
                            color: "#555",
                            position: "relative",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                              height: "100%",
                              zIndex: 0,
                            }}
                          >
                            {(collab?.name || collab?.email || "?").charAt(0).toUpperCase()}
                          </span>
                          {collab?.teacher_profile_pic ? (
                            <img
                              src={collab.teacher_profile_pic}
                              alt=""
                              style={{
                                position: "absolute",
                                inset: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                zIndex: 1,
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ) : null}
                        </div>
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "#232323",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {collab?.name || collab?.email || "-"}
                        </span>
                      </div>
                      {isOwner ? (
                        <span
                          className="access-role-text"
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "#555",
                            flexShrink: 0,
                            width:'17%'
                          }}
                        >
                          Owner
                        </span>
                      ) : (
                        <div
                          className="access-role-dropdown-wrapper"
                          data-access-role-key={rowKey}
                          style={{ position: "relative", display: "inline-block", flexShrink: 0, width:'17%' }}
                        >
                          <button
                            type="button"
                            className="access-role-dropdown-trigger"
                            onClick={() => setOpenAccessRoleKey(isOpen ? null : rowKey)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontFamily: "inherit",
                              fontWeight: 600,
                              color: "#555",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              // gap: "35px",
                              width: "6rem",
                              // maxWidth: "90%",
                              padding:'0px'
                            }}
                          >
                            <span >{currentLabel}</span>
                            <span style={{ fontSize: "10px", opacity: 0.7, paddingTop: "3px" }}>▼</span>
                          </button>
                          {isOpen && (
                            <div
                              className="access-role-dropdown-menu"
                              style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                marginTop: "4px",
                                minWidth: "140px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                padding: "6px 0",
                                zIndex: 1000,
                              }}
                            >
                              {accessOptions.map((opt, i) => (
                                <Fragment key={opt.value}>
                                  {i > 0 && (
                                    <div
                                      style={{
                                        height: "1px",
                                        backgroundColor: "#e0e0e0",
                                        margin: "0 12px",
                                      }}
                                    />
                                  )}
                                  <button
                                    type="button"
                                    className="access-role-dropdown-option"
                                    onClick={() => handleSelectRole(opt.value)}
                                    style={{
                                      display: "block",
                                      width: "100%",
                                      border: "none",
                                      background: "none",
                                      padding: "10px 16px",
                                      fontSize: "inherit",
                                      fontFamily: "inherit",
                                      color: "#232323",
                                      textAlign: "left",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = "#f5f5f5";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = "transparent";
                                    }}
                                  >
                                    {opt.label}
                                  </button>
                                </Fragment>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    padding: "24px 16px",
                    textAlign: "center",
                    color: "#888",
                    fontSize: "14px",
                  }}
                >
                  No collaborators yet
                </div>
              )}
            </div>
            <div className="add-teacher-modal-actions">
              <button
                type="button"
                className="add-teacher-cancel-btn"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="add-modal-add-teacher-btn"
                disabled={teacherEmails.length <= 0 || addTeacherState?.isLoading}
                onClick={handleInviteTeachers}
                style={{ backgroundColor: teacherEmails.length <= 0 || addTeacherState?.isLoading ? "#9e9e9e" : "#0068ff" }}
              >
                {addTeacherState?.isLoading ? (
                  "Inviting..."
                ) : (
                  <>
                    <i className="fa-solid fa-user-plus mr-1"></i>
                    Invite
                  </>
                )}
              </button>
            </div>
          </div>
            <div ref={modalRef} className="mobile-invite-modal">
              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-[16px] font-semibold m-0">Add Teacher</h2>
                <button type="button" onClick={closeModal}
                  className="bg-transparent border-none cursor-pointer text-[18px] text-[#000]">
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>

              {/* Email Input Box */}
              <div
                style={{
                  padding: "10px 12px", border: teacherFormErrors.teachers ? "1px solid red" : "1px solid #d0d0d0",
                  borderRadius: "8px", backgroundColor: "#fff", display: "flex",
                  flexWrap: "wrap", gap: "8px", alignItems: "center", marginBottom: "8px"
                }}
              >
                {teacherEmails.map((item, index) => {
                  const email = typeof item === "string" ? item : item.email;
                  return (
                    <span key={`${email}-${index}`}
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "5px 10px 5px 12px", backgroundColor: "#e8e8e8", borderRadius: "16px", fontSize: "0.9rem" }}
                    >
                      {email}
                      <button type="button" onClick={() => handleDeleteTeacher(email)}
                        style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#666", fontSize: "14px" }}>
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </span>
                  );
                })}
                <input
                  type="text"
                  name="teachers"
                  placeholder={teacherEmails.length === 0 ? "Add email to invite" : ""}
                  value={teacherInputValue}
                  onChange={handleTeacherInputChange}
                  onKeyDown={handleTeacherKeyDown}
                  onPaste={handleTeacherPaste}
                  style={{ flex: "1 1 140px", minWidth: "140px", border: "none", outline: "none", padding: "6px 4px", fontSize: "14px" }}
                />
              </div>

              {teacherFormErrors.teachers && (
                <p style={{ color: "red", fontSize: "0.8rem", margin: "0 0 8px 0" }}>{teacherFormErrors.teachers}</p>
              )}

              {/* Role Selector */}
              {teacherEmails.length > 0 && (
                <div style={{ position: "relative", width: "100%" }}>
                <select
                  value={teacherEmails.length > 1 && teacherRole === "owner" ? "editor" : teacherRole}
                  onChange={(e) => setTeacherRole(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 32px 10px 12px",
                    borderRadius: "8px",
                    border: "1px solid rgb(208, 208, 208)",
                    fontSize: "14px",
                    marginBottom: "12px",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                  }}
                >
                  {teacherEmails.length === 1 && <option value="owner">Owner</option>}
                  <option value="editor">Editor</option>
                  <option value="viewer">Viewer</option>
                </select>
                <span style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-60%)",
                  fontSize: "10px",
                  color: "#000",
                  pointerEvents: "none",  // ← so clicks pass through to select
                }}>
                  ▼
                </span>
                </div>
              )}

              {/* Collaborators List */}
              <div style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "12px" }}>
                {Array.isArray(collaboratorsList) && collaboratorsList.length > 0 ? (
                  collaboratorsList.map((collab, index) => {
                    const roleCode = (collab?.teacher_collaborator_roles?.code ?? "").toString().toLowerCase();
                    const roleLabels = { owner: "Owner", editor: "Editor", viewer: "Viewer", remove_user: "Remove User" };
                    const currentLabel = roleLabels[roleCode] ?? "Editor";
                    const isOwner = roleCode === "owner";
                    const rowKey = collab?.id ?? collab?.teacher_id ?? collab?.email;

                    return (
                      <div key={rowKey} className="flex items-center justify-between py-2 gap-3">
                        <div className="flex items-center gap-2 flex-1 min-w-0">
                          <div style={{ width: "36px", height: "36px", borderRadius: "50%", overflow: "hidden", flexShrink: 0, backgroundColor: "#e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, color: "#555", position: "relative" }}>
                            {(collab?.name || collab?.email || "?").charAt(0).toUpperCase()}
                            {collab?.teacher_profile_pic && (
                              <img src={collab.teacher_profile_pic} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.target.style.display = "none"; }} />
                            )}
                          </div>
                          <span className="text-[13px] font-semibold text-[#232323] truncate">{collab?.name || collab?.email || "-"}</span>
                        </div>
                        {isOwner ? (
                          <span style={{ fontWeight: 600, fontSize: "14px", color: "#000", flexShrink: 0, flex:0.2 }}>Owner</span>
                        ) : (
                          <div
                            data-access-role-key={rowKey}
                            style={{ position: "relative", display: "inline-block", flexShrink: 0, flex:0.2 }}
                          >
                            <button type="button"
                              onClick={() => setOpenAccessRoleKey(openAccessRoleKey === rowKey ? null : rowKey)}
                              style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: "14px", fontWeight: 600, color: "#555", display: "flex", alignItems: "center", gap: "22px", padding: 0 }}
                            >
                              <span style={{color:"#000"}}>{currentLabel}</span>
                              <span style={{ fontSize: "10px", opacity: 0.7 , color:"#000"}}>▼</span>
                            </button>
                            {openAccessRoleKey === rowKey && (
                              <div style={{ position: "absolute", top: "100%", right: 0, marginTop: "4px", minWidth: "140px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.12)", padding: "6px 0", zIndex: 1000 }}>
                                {[{ value: "owner", label: "Owner" }, { value: "editor", label: "Editor" }, { value: "viewer", label: "Viewer" }, { value: "remove_user", label: "Remove User" }].map((opt, i) => (
                                  <Fragment key={opt.value}>
                                    {i > 0 && <div style={{ height: "1px", backgroundColor: "#e0e0e0", margin: "0 12px" }} />}
                                    <button type="button"
                                      onClick={() => {
                                        if (opt.value === "owner") { setIsOpen(false); setTransferCollaboratorPayload({ collab }); }
                                        else if (course?.course_id && token && collab?.id) { dispatch(addTeacher(course.course_id, { id: collab.id, role: opt.value }, token, true)); }
                                        setOpenAccessRoleKey(null);
                                      }}
                                      style={{ display: "block", width: "100%", border: "none", background: "none", padding: "10px 16px", fontSize: "14px", color: "#232323", textAlign: "left", cursor: "pointer" }}
                                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f5f5f5"; }}
                                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                                    >
                                      {opt.label}
                                    </button>
                                  </Fragment>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center text-[13px] text-[#888]">No collaborators yet</p>
                )}
              </div>

              {/* Footer Buttons */}
              <div className="flex gap-3 mt-2">
                <button type="button"
                  className="flex-1 py-2 rounded-lg text-[14px] cursor-pointer"
                  style={{ border: '1px solid #e0e0e0', background: 'white', color: '#000' }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="button"
                  className="flex-1 py-2 rounded-lg text-white text-[14px] cursor-pointer flex items-center justify-center gap-2"
                  style={{ background: teacherEmails.length <= 0 || addTeacherState?.isLoading ? '#9e9e9e' : '#0068ff', border: 'none' }}
                  disabled={teacherEmails.length <= 0 || addTeacherState?.isLoading}
                  onClick={handleInviteTeachers}
                >
                  {addTeacherState?.isLoading ? "Inviting..." : <><i className="fa-solid fa-user-plus"></i> Invite</>}
                </button>
              </div>
            </div>
        </div>
      )}
    </>
  );
};

export default AddTeachers;
